import { normalizeWebsiteUrl } from './chefDisplay';

const BLOCKED_SCHEME_RE = /^(javascript|data|vbscript|file):/i;

/** Returns an http(s) href safe for `<a href>` and `window.open`, or null if rejected. */
export function sanitizeExternalHref(raw: string | undefined | null): string | null {
    const trimmed = raw?.trim();
    if (!trimmed) return null;
    if (BLOCKED_SCHEME_RE.test(trimmed)) return null;

    const normalized = normalizeWebsiteUrl(trimmed);
    if (!normalized) return null;

    try {
        const parsed = new URL(normalized);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
        return parsed.href;
    } catch {
        return null;
    }
}

export function sanitizeExternalHrefs(links: readonly string[]): string[] {
    const seen = new Set<string>();
    const result: string[] = [];
    for (const link of links) {
        const safe = sanitizeExternalHref(link);
        if (!safe) continue;
        const key = safe.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        result.push(safe);
    }
    return result;
}
